module.exports = __webpack_public_path__ + "img/fan_control.a9290c28.svg";